import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const key = ['shutdownAlisaTemplates'];

const shutdownAlisaTemplatesQuery = async () => {
  return await request.get(
    `/Alert/alisa_templates`,
    {},
    `При загрузке автоответчиков произошла ошибка`
  );
};

export const useShutdownAlisaTemplates = (options) =>
  useQuery(key, shutdownAlisaTemplatesQuery, options);
